<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='预发住培奖金设置' url='/achievement/set/delivermoneymonth'></SearchTitle>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">预发开始月：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-select v-model="form.startmonth">
                  <el-option v-for="item in monthoptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">预发结束月：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-select v-model="form.endmonth">
                  <el-option v-for="item in monthoptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">指定扣除月：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-select v-model="form.appointmonth">
                  <el-option v-for="item in monthoptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12" style="text-align: center;">
                  <SaveButton :url="saveUrl" back="/achievement/set/delivermoneymonth"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DeliverMoneyMonth',
    data() {
      return {
        form: {
          id: '',
          startmonth:'',
          endmonth:'',
          appointmonth:'',
          token: ''
        },
        monthoptions: [{
          label: '1月',
          value: 1
        }, {
          label: '2月',
          value: 2
        }, {
          label: '3月',
          value: 3
        }, {
          label: '4月',
          value: 4
        }, {
          label: '5月',
          value: 5
        }, {
          label: '6月',
          value: 6
        }, {
          label: '7月',
          value: 7
        }, {
          label: '8月',
          value: 8
        }, {
          label: '9月',
          value: 9
        }, {
          label: '10月',
          value: 10
        }, {
          label: '11月',
          value: 11
        }, {
          label: '12月',
          value: 12
        }],
        saveUrl: this.$utils.Url.zpgl + '/api/APIDeliverMoneyMonth/Add'
      }
    },
    methods:{
      LoadInfo:function(){
        this.loading = true
        var args = {
          pageSize: 999,
          currentPage: 1,
        }
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIDeliverMoneyMonth/List', args)
          .then(res => {
            if (res.data.Code === 0) {
              if(res.data.Data.length >0){
                that.form.id = res.data.Data[0]["ID"]
                that.form.startmonth = res.data.Data[0]["StartMonth"]
                that.form.endmonth = res.data.Data[0]["EndMonth"]
                that.form.appointmonth = res.data.Data[0]["AppointMonth"]
                that.saveUrl = this.$utils.Url.zpgl + '/api/APIDeliverMoneyMonth/Update'
              }
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      this.LoadInfo()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .col-lg-1 {
    padding-left: 0px;
    padding-right: 0px;
  }
</style>
